import React from 'react';
import ChatGPTPanel from '../components/ChatGPTPanel';

const Chat: React.FC = () => <ChatGPTPanel />;

export default Chat; 